export default "__VITE_ASSET__CRh6FmP___"